import React, { useEffect, useState } from 'react'
import 'antd/dist/antd.css';
import "./QuestionContainer.css"
import { Button } from 'antd';
import Java from './JavaQuestion/Java'
// import QuestionSection from './QuestionSection'
import { useNavigate } from "react-router-dom"
import ReactQues from './ReactQuestion/ReactQues';
import Html from './HtmlQuestion/Html';
import Coding from './Coding/Coding';

function QuestionContainer() {
    let navigate = useNavigate()
    // let limit = 0
    let [timer, setTimer] = useState(5000)
    let [score, setScore] = useState(0)
    const [switchQuestionSection, setSwitchQuestionSection] = useState("html")
    const htmlQuesSecHanndle = () => {
        setSwitchQuestionSection("html")
    }
    const javaQuesSecHanndle = () => {
        setSwitchQuestionSection("java")
    }
    const reactQuesSecHanndle = () => {
        setSwitchQuestionSection("react")
    }
    // const codingQuesSecHanndle=()=>{
    //     setSwitchQuestionSection("coding")
    // }

    const goToResult = () => {

        console.log("+++ k++=")
        console.log("+k", scoreHandle);
        navigate("/result")
        //         var url = window.location.href;
        // window.history.go(-window.history.length);
        // window.location.href = url;
    }
const tttt=()=>{
    // setTimeout(() => {
        
    //   }, 0.000001);
      window.history.forward()
      window.onunload = (() => {window.history= null });

}
 useEffect(() => {
     console.log("testing")
  tttt()
  }, [])
    const scoreHandle = () => {
        setScore(score + 1)
        alert(score)

    }
    const autoCall = () => {

        console.log("++ hello +++")
        if (timer > 0) {
            setTimeout(() => {
                setTimer(--timer)
                if (timer === 0) {
                    navigate("/timefinished")

                }
            }, 1000)
        }
        // if(timer==0){
        //     alert("pp")
        // }
    }


    return (
        <div style={{}}>
            {/* <div style={{textAlign:"right",marginRight:"5%",fontSize:'20px',padding:'10px 0'}}>
         <button style={{backgroundColor:"crimson",padding:'8px 25px',marginRight:"20px",outline:"none",
                border:"none",color:"white",borderRadius:"5px"}} onClick={scoreHandle}>Submit</button><span 
                style={{fontWeight:"bold"}} onClick={autoCall()} >Time Left - {timer}</span>
         </div> */}
            <div style={{ display: "flex", alignItems: 'center', justifyContent: "end", padding: '10px 100px' }}>
                <Button onClick={goToResult} style={{ marginRight: "15px" }}
                    type="primary" htmlType="submit">
                    Submit
                </Button>
                <span
                    style={{ fontWeight: "bold" }} onClick={autoCall()} 
                    >Time Left - {timer}
                    </span>
            </div>

            <div className='questionContainer'>
                <div className='questionContainerLeft'>
                    {/* <QuestionSection /> */}
                    
                        <Button onClick={htmlQuesSecHanndle}
                            type="primary" htmlType="submit">
                            Html
                        </Button>
                        <Button onClick={javaQuesSecHanndle}  type="primary" htmlType="submit">
                            java
                        </Button>
                        <Button onClick={reactQuesSecHanndle}  type="primary" htmlType="submit">
                            React
                        </Button>
                        {/* <Button onClick={codingQuesSecHanndle}  type="primary" htmlType="submit">
                            Coding
                        </Button> */}
                                        {/* <div > <button  style={{
                            width:'100%',
                            padding:"6px 0",
                            marginBottom:"15px",
                            backgroundColor:"crimson",
                            color:'white',
                            border:'none',
                            outline:"none",
                            borderRadius:'5px'
                        }} >React</button>   </div>
                        <div> <button style={{
                            width:'100%',
                            padding:"6px 0",
                            marginBottom:"15px",
                            backgroundColor:"crimson",
                            color:'white',
                            border:'none',
                            outline:"none",
                            borderRadius:'5px'
                        }} >java</button>   </div> */}

                    
                </div>
                <div className='questionContainerRight'>
                    {switchQuestionSection === "html" && (
                        <Html />
                    )
                    }
                    {switchQuestionSection === "java" && (
                        <Java />
                    )
                    }
                    {switchQuestionSection === "react" && (
                        <ReactQues />
                    )
                    }
                    {switchQuestionSection === "coding" && (
                        <Coding />
                    )
                    }
                </div>
            </div>

        </div>
    )
}

export default QuestionContainer
